export { isEnvironmentAvailable, isAuthenticationAvailable, isRainbowAuthentication, isSsoAuthentication, getSelectedServerUrl, getBaseServerUrl, getSelectedLoginUrl, AUTHENTICATION_TYPES } from "../../middleware/Utils/AuthenticationUtils"
export { getQueryParameterInPathString } from "./PathUtils";


export const WebClientPrefix = "web.";
// export const SandBoxWebClientPrefix = "web-"; in developersConstant
